module.exports = __webpack_public_path__ + "img/link.035e0216.svg";